// Firebase configuration for insatiable-e0f18 project

const firebaseConfig = {
  apiKey: "AIzaSyBraw2Hawj6QNQY3v1KnsuHzR1uS6ypLkI",
  authDomain: "insatiable-e0f18.firebaseapp.com",
  projectId: "insatiable-e0f18",
  storageBucket: "insatiable-e0f18.firebasestorage.app",
  messagingSenderId: "999962786729",
  appId: "1:999962786729:web:90a04c1eb1dac56fcfe2b8",
  measurementId: "G-W8M7MJK3DH"
};

// Firebase configuration for founders-first project
const foundersFirstFirebaseConfig = {
  apiKey: "AIzaSyBraw2Hawj6QNQY3v1KnsuHzR1uS6ypLkI", // May need to update with founders-first project key
  authDomain: "founders-first.firebaseapp.com",
  projectId: "founders-first",
  storageBucket: "founders-first.firebasestorage.app",
  messagingSenderId: "999962786729", // May need to update
  appId: "1:999962786729:web:90a04c1eb1dac56fcfe2b8" // May need to update
};

// For development, you can use Firebase emulators
const useEmulators = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true';

export { firebaseConfig, foundersFirstFirebaseConfig, useEmulators }; 